import { render, staticRenderFns } from "./BookingSetupForm.vue?vue&type=template&id=63ab812c&scoped=true&"
import script from "./BookingSetupForm.vue?vue&type=script&lang=js&"
export * from "./BookingSetupForm.vue?vue&type=script&lang=js&"
import style0 from "./BookingSetupForm.vue?vue&type=style&index=0&id=63ab812c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab812c",
  null
  
)

export default component.exports